import { type FC } from 'react';
import classnames from 'classnames';

import dibsCss from 'dibs-css';

export const PdpRespSharedQrCode: FC<{ itemId: string | null }> = ({ itemId }) => {
    if (!itemId) {
        return null;
    }

    return (
        <img
            alt=""
            className={classnames(dibsCss.maxW100px, dibsCss.maxH100px, dibsCss.mtSmall)}
            src={`https://node-lambda.1stdibs.com/prod/qrcode.png?item=${itemId}&width=400&addlQuery=utm_source%3Dqr-code%26utm_medium%3Demail%26utm_campaign%3Dprint-page`}
        />
    );
};

// lazy load
export default PdpRespSharedQrCode;
